import SellingPrice from '../../../../components/editable-cell/form-items/selling-price'
import type { ShipmentColumn } from '../../types/column-types'
import { onAnyStandardCell } from '../../helpers/helpers'
import { blue } from '@ant-design/colors'

export const sellingPriceColumn: ShipmentColumn = {
    key: 'sellingPrice',
    dataIndex: 'sellingPrice',
    title: 'Отп. цена',
    width: 80,
    editable: true,
    onHeaderCell: () => ({
        style: {
            backgroundColor: blue[1],
        },
    }),
    FormItem: <SellingPrice />,
    onCell: record => {
        return {
            ...onAnyStandardCell(record),
            style: {
                backgroundColor: blue[1],
            },
        }
    },
}
